module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_8019.6b85b244.png";